import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';

export function SocialProofFadeFooter({
  hiddenPapersCount,
}: {
  hiddenPapersCount: number;
}) {
  if (hiddenPapersCount <= 0) return null;
  return (
    <FooterWrap>
      <FooterInner>
        <Body size="lg" bold as="strong">
          +{hiddenPapersCount}
        </Body>
        <Body size="xs" as="span">
          related research papers
        </Body>
        <SocialLine>
          <Body size="xs" as="span">
            1,000+ researchers downloaded this month
          </Body>
        </SocialLine>
      </FooterInner>
    </FooterWrap>
  );
}

const FooterWrap = styled.div`
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
  height: 96px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: var(--spacing-xs-12, 12px);
  background: linear-gradient(
    180deg,
    rgba(244, 247, 252, 0) 5.8%,
    rgba(244, 247, 252, 0.5) 13.34%,
    rgba(244, 247, 252, 0.74) 22.1%,
    rgba(244, 247, 252, 0.77) 28.48%,
    #f4f7fc 39.01%
  );
  pointer-events: none;
`;

const FooterInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  color: var(--text-primary, #141413);
`;

const SocialLine = styled.div`
  color: var(--text-secondary, #535366);
  margin-top: 2px;
`;
